import { DateInput, Filter, SearchInput, usePermissions } from "react-admin";
import ProvinceInput from "./inputs/ProvinceInput";
import React from "react";
import { StateInput } from "ra-friendsofbabba";

const Filters = (props) => {
  const { loaded, permissions } = usePermissions();
  const isInternalUser = loaded && permissions(["admin", "region", "readonly"]);
  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn />
      <StateInput source="state" alwaysOn />
      {isInternalUser && <ProvinceInput source="province" alwaysOn />}
      {isInternalUser && <DateInput source="sent" alwaysOn />}
    </Filter>
  );
};
export default Filters;
